import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseApi, BASE_URL } from "@edl-development/edl-common";
import { DiffObservationSection } from "src/app/model/enum/observations/diff/diff-observation-section.enum";
import { DiffActionPlanDTO } from "src/app/model/observation/diff/diff-action-plan-dto.model";
import { CreateObservationDTO } from "src/app/model/observation/diff/diff-create-dto.model";
import { DiffModel } from "src/app/model/observation/diff/diff.model";
import { ObservationSummaryDTO } from "src/app/model/observation/observation-summary-dto.model";

@Injectable()
export class DiffApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    createDiff(diffCreateDto: CreateObservationDTO) {
        return this.http.post<ObservationSummaryDTO>(this.baseUri + '/observation/diff/create', diffCreateDto);
    }

    getDetails(userId: string, diffId: string) {
        return this.http.get<DiffModel>(this.baseUri + '/observation/diff/' + diffId, {});
    }

    updateActionPlan(actionPlan: DiffActionPlanDTO) {
        return this.http.put(this.baseUri + '/observation/diff/updateActionPlan/', actionPlan);
    }

    submitActionPlan(actionPlan: DiffActionPlanDTO) {
        return this.http.put(this.baseUri + `/observation/diff/submitActionPlan/`, actionPlan);
    }

    submitDiff(diffObservationId: string, section: DiffObservationSection) {
        return this.http.put(this.baseUri + `/observation/diff/${diffObservationId}/submit/${section as number}`, {});
    }

    submitSignature(diffObservationId: string, signature: string) {
        return this.http.put(this.baseUri + `/observation/diff/${diffObservationId}/submitSignature/` + signature, {});
    }

    unauthenticate(diffObservationId: string) {
        return this.http.put(this.baseUri + `/observation/diff/${diffObservationId}/unauthenticate/`, {});
    }

    submitFeedback(diffObservationId: string) {
        return this.http.put(this.baseUri + `/observation/diff/${diffObservationId}/feedback`, {});
    }
}